import _ from 'lodash'

const DEFAULT_COLUMNS = [
  { key: 'Katalognr', default: '', name: 'Kat.nr', sortKey: 'Katalognr', class: 'c-number sorttable_numeric', readonly: true, selected: true },
  { key: 'photo_thumb', default: '', name: 'Bilde', sortKey: '', class: 'c-image unsortable', readonly: true, selected: true },
  { key: 'kunstner.Navn', default: '-', name: 'Kunstner', sortKey: 'kunstner.Navn', class: '', selected: true },
  { key: 'Katalogtekst1', default: '-', name: 'Tittel', sortKey: 'Katalogtekst1', class: 'nowrap', tooltip: true, selected: true },

  { key: 'Minstepris', default: '', name: 'Minstepris', sortKey: 'Minstepris', class: 'align-left', filter: 'integer', selected: true },
  { key: 'Vurderingspris2', default: '', name: 'Lav', sortKey: 'Vurderingspris2', class: 'align-left', filter: 'integer', selected: true },
  { key: 'Vurderingspris1', default: '', name: 'Høy', sortKey: 'Vurderingspris1', class: 'align-left', filter: 'integer', selected: true },
  { key: 'forhandsbud.Bud', default: '', name: 'Bud', sortKey: '', class: 'unsortable', filter: 'integer', selected: true },
  { key: 'forhandsbud.Budnr', default: '', name: 'Spadenr', sortKey: '', class: 'unsortable', filter: 'integer', selected: true },
  { key: 'forhandsbud.kunde.parsed_name', default: '', name: 'Kunde', sortKey: '', class: 'unsortable', selected: true },
  { key: 'forhandsbud.kunde.Kundenr', default: '', name: 'Kundenr', sortKey: '', class: 'unsortable', selected: true },
  { key: 'forhandsbud.kunde.Mobil', default: '', name: 'Mobil', sortKey: '', class: 'unsortable', selected: true },
  { key: 'forhandsbud.kunde.Tlfprivat', default: '', name: 'Tlfprivat', sortKey: '', class: 'unsortable', selected: true },
  { key: 'forhandsbud.kunde.Tlfarbeid', default: '', name: 'Tlfarbeid', sortKey: '', class: 'unsortable', selected: true },
  { key: 'forhandsbud.Merknad', default: '', name: 'Merknad', sortKey: '', class: 'unsortable', selected: true }
]

const DEFAULT_IMAGE_SIZES = [
  { key: 'c-image-none', name: 'Ingen bilder', selected: false },
  { key: 'c-image-small', name: 'Små bilder', selected: true },
  { key: 'c-image-medium', name: 'Mellomstore bilder', selected: false },
  { key: 'c-image-large', name: 'Store bilder', selected: false }
]

const LS_KEY = 'advancebids-search-values'
const LS_KEY_COLS = 'columns'
const LS_KEY_IMAGE_SIZES = 'imagesizes'

const state = {
  defaultColumns: null,
  defaultImageSizes: null
}

const loadLs = (key = null) => {
  try {
    const retval = JSON.parse(localStorage.getItem(LS_KEY) || {})

    if (key === null) {
      return retval
    }

    if (!retval.hasOwnProperty(key)) {
      return null
    }

    return retval[key]
  } catch (e) {
    return null
  }
}

const saveLs = (key, data) => {
  try {
    const stored = loadLs() || {}
    stored[key] = data
    localStorage.setItem(LS_KEY, JSON.stringify(stored))
  } catch (e) {
    // Ignore
  }
}

const getters = {
  columns: state => {
    if (!state.defaultColumns) {
      let retval = loadLs(LS_KEY_COLS) || DEFAULT_COLUMNS

      // How we get possibly new cols added...
      if (retval !== DEFAULT_COLUMNS) {
        retval = _.uniqBy([...retval, ...DEFAULT_COLUMNS], 'key')
      }

      return retval
    }

    return state.defaultColumns
  },
  imagesizes: state => {
    if (!state.defaultImageSizes) {
      return loadLs(LS_KEY_IMAGE_SIZES) || DEFAULT_IMAGE_SIZES
    }

    return state.defaultImageSizes
  },
  selectedImageSize: (state, getters) => {
    return getters.imagesizes.find(i => i.selected === true)
  }
}

const actions = {
  saveImageSizes: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveImageSizes', payload)
      resolve()
    })
  },
  saveColumns: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveColumns', payload)
      resolve()
    })
  },
  resetColumns: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit('resetColumns')
      resolve()
    })
  }
}

const mutations = {
  'saveImageSizes': (state, payload) => {
    state.defaultImageSizes = payload
    saveLs(LS_KEY_IMAGE_SIZES, payload)
  },
  'saveColumns': (state, payload) => {
    state.defaultColumns = payload
    saveLs(LS_KEY_COLS, payload)
  },
  'resetColumns': (state) => {
    state.defaultColumns = DEFAULT_COLUMNS
    saveLs(LS_KEY_COLS, DEFAULT_COLUMNS)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/forhandsbud.js